export default "__VITE_ASSET__CLxcVGJI__"